import { render } from "./footer-comp.vue?vue&type=template&id=2b6951a8&scoped=true"
import script from "./footer-comp.vue?vue&type=script&lang=js"
export * from "./footer-comp.vue?vue&type=script&lang=js"

import "./footer-comp.vue?vue&type=style&index=0&id=2b6951a8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6951a8"]])

export default __exports__